import { useCallback } from 'react';
import { map } from 'lodash';
import { Typography, Stack } from '@mui/material';
import { useDispatch, useListeners, useSelector } from '@client/hooks/redux.hooks';
import { Select, MenuItem } from '@client/components/forms/Select';
import { Checkbox } from '@client/components/forms/Checkbox';
import { getGenres } from '@client/selectors/entities/categories';
import { FormStack } from '@client/components/forms/FormStack';
import { getSelectedProfile } from '@client/selectors/helpers/profile';
import { ProfileTypes } from '@sda/enums';
import { SignupWrapperForm } from '../../common/SignupWrapper/SignupWrapperForm';
import { signupArtistGenresListeneners, startSaveArtistGenres } from './signup-artist-genres.listeners';
import { SignupArtistGenresSchema } from './signup-artist-genres.schema';

const Explainer = (
  <Stack spacing={2}>
    <Typography
      variant="h6"
      align="left"
    >
      Project details
    </Typography>

    <Typography
      color="textSecondary"
      align="left"
    >
      We know genres aren't perfect, but they do help hosts understand your project.
    </Typography>
  </Stack>
);

export const Genres = () => {
  const dispatch = useDispatch();
  const selectedProfile = useSelector(getSelectedProfile);

  const genres = useSelector(getGenres);

  useListeners(signupArtistGenresListeneners);

  const initialValues = {
    primaryGenre: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.primaryGenre || '' : '',
    secondaryGenre: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.secondaryGenre || '' : '',
    requiresPA: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.requiresPA || false : false,
  };

  const handleSubmit = useCallback((values: typeof initialValues) => {
    dispatch(startSaveArtistGenres(values));
  }, [dispatch]);

  return (
    <SignupWrapperForm
      steps={6}
      currentStep={2}
      renderExplainer={Explainer}
      FormikProps={{
        initialValues,
        onSubmit: handleSubmit,
        validationSchema: SignupArtistGenresSchema,
      }}
      buttonProps={() => ({
        scope: 'signup-act-genres-form',
      })}
    >
      <FormStack>
        <Select
          name="primaryGenre"
          label="Primary genre"
          fullWidth
        >
          {map(genres, (genre) => (
            <MenuItem
              key={genre.id}
              value={genre.id}
            >
              {genre.lang.label}
            </MenuItem>
          ))}
        </Select>

        <Select
          name="secondaryGenre"
          label="Secondary genre"
          fullWidth
        >
          {map(genres, (genre) => (
            <MenuItem
              key={genre.id}
              value={genre.id}
            >
              {genre.lang.label}
            </MenuItem>
          ))}
        </Select>

        <Checkbox name="requiresPA">
          I require a PA system
        </Checkbox>
      </FormStack>
    </SignupWrapperForm>
  );
};
